import React from 'react';
import styled from 'styled-components';

const Label = styled.label`
  font-size: 14px;
  color: var(--gray-03);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledSelect = styled.select`
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px;
  max-width: 300px;
  width: 100%;
  font-size: 14px;
  color: var(--gray-03);
  &:focus {
    outline: none;
  }

  option {
    color: var(--gray-03);
  }

  option:checked {
    color: var(--gray-03);
  }

  option:active {
    color: var(--gray-03);
  }

  option:hover {
    color: var(--gray-03);
  }

  option:disabled {
    color: var(--gray-03);
  }

  option:disabled:hover {
    color: var(--gray-03);
  }
`;

type Props = {
  id?: string;
  name?: string;
  options: { value: string; label: string }[];
  label?: string;
  selected?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
};

export const Select: React.FC<Props> = (props) => {
  return (
    <Label htmlFor={props.id}>
      {props.label && props.label}
      <StyledSelect
        disabled={props.disabled}
        id={props.id}
        name={props.name}
        defaultValue={props.selected}
        onChange={(event) => props.onChange && props.onChange(event.target.value)}
      >
        {props.options.map((option) => (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
    </Label>
  );
};
